<template>
  <div class="no-permissions-page">
    You don't have any permissions in this page. <br />
    Please contact your company's admin .
  </div>
</template>

<script>
export default {
  name: "NoPermissionsPage"
};
</script>

<style scoped>
.no-permissions-page {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #515358;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/NoPermissionsPage.vue